export default {
  removeBody(element) {
    let bodyx = document.body
    bodyx.removeChild(element);
  }
}
